document.addEventListener('DOMContentLoaded', () => {
  const desktopContent = document.getElementById('desktopNavContent');
  
  const bg = document.getElementById('desktopNavBackground');
  const items = document.querySelectorAll('.header-menu-item');
  const panels = document.querySelectorAll('.header-menu_item_content');

  let activeId = null;

  const hideAllPanels = () => panels.forEach(p => (p.style.display = 'none'));

  const closeAll = () => {
    hideAllPanels();
    bg.style.display = 'none';
    document.body.classList.remove('modal-open');
    activeId = null;
  };

  bg.addEventListener('click', closeAll);

  items.forEach(item => {
    item.addEventListener('click', () => {
      const id = item.dataset.menuId;

      if (activeId === id) return closeAll();

      hideAllPanels();

      const panel = document.querySelector(
        `.header-menu_item_content[data-menu-id="${id}"]`
      );

      if (!panel) return closeAll();

      document.body.classList.add('modal-open');
      panel.style.display = 'block';
      bg.style.display = 'block';
      activeId = id;
    });
  });

  /* ============================================================
     MOBILE SEARCH TOGGLE
     ============================================================ */

  const mobileSearchBtn = document.querySelector('.site-header-mobile-search-button');
  const searchWrapper = document.querySelector('.search-bar-wrapper');
  const siteMainDimmer = document.querySelector('.site-main-dimmer');

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
  }

  function openMobileSearch() {
    if (!searchWrapper) return;

    searchWrapper.style.display = 'flex';
    searchWrapper.style.position = 'absolute';
    searchWrapper.style.top = '60px';
    searchWrapper.style.left = '0';
    searchWrapper.style.right = '0';
    searchWrapper.style.zIndex = '1100';

    if (siteMainDimmer) {
      siteMainDimmer.style.display = 'block';
    }

    // optional: close menus so the search isn't fighting nav
    closeAllMenus();

    // optional: focus input if it exists
    const input = searchWrapper.querySelector('input[type="search"], input[name="q"], input');
    if (input) input.focus();
  }

  function closeMobileSearch() {
    if (searchWrapper) {
      searchWrapper.style.display = 'none';
    }

    if (siteMainDimmer) {
      siteMainDimmer.style.display = 'none';
    }
  }

  function toggleMobileSearch() {
    if (!isMobile()) return;
    if (!searchWrapper) return;

    isVisible(searchWrapper) ? closeMobileSearch() : openMobileSearch();
  }

  // tap icon toggles search (mobile only)
  if (mobileSearchBtn) {
    mobileSearchBtn.addEventListener('click', (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      e.stopPropagation(); // prevents the document click closer firing immediately
      toggleMobileSearch();
    });
  }

  // tap dimmer closes search + hides dimmer
  if (siteMainDimmer) {
    siteMainDimmer.addEventListener('click', (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      closeMobileSearch();
      closeAllMenus(); // optional consistency
    });
  }

  // tap outside closes search (mobile only)
  document.addEventListener('click', (e) => {
    if (!isMobile()) return;
    if (!searchWrapper || !mobileSearchBtn) return;

    const insideSearch = e.target.closest('.search-bar-wrapper');
    const insideBtn = e.target.closest('.site-header-mobile-search-button');

    if (!insideSearch && !insideBtn) {
      closeMobileSearch();
    }
  });

  // ESC closes both desktop menus + mobile search
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllMenus();
      closeMobileSearch();
    }
  });

  // rotate/resize up to desktop => hide mobile search + dimmer
  window.addEventListener('resize', () => {
    if (!isMobile()) closeMobileSearch();
  });
});
